export default {
  FULL_AMENITIES: 'full',
  NO_AMENITIES: 'none',
  LIMITED_AMENITIES: 'limited',
  NO_POWER: 'no-power',
  UNKNOWN: 'unknown',
};
